import script from "./CareerAdvantages.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerAdvantages.vue?vue&type=script&setup=true&lang=js"

import "./CareerAdvantages.vue?vue&type=style&index=0&id=0e3487a8&lang=scss"

const __exports__ = script;

export default __exports__